
export default function StatsSection() {
  const stats = [
    {
      number: "500+",
      label: "Projects Completed",
      description: "Successful installations worldwide"
    },
    {
      number: "40+",
      label: "Years Experience",
      description: "Industry expertise and innovation"
    },
    {
      number: "50+",
      label: "Countries Served",
      description: "Global reach and support"
    },
    {
      number: "99.8%",
      label: "Client Satisfaction",
      description: "Proven quality and reliability"
    }
  ];

  return (
    <section className="py-20 bg-blue-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Trusted by <strong>Aviation Professionals</strong> Worldwide
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Our track record speaks for itself - delivering excellence in aircraft shelter solutions across the globe.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">{stat.number}</div>
              <div className="text-xl font-semibold text-blue-100 mb-1">{stat.label}</div>
              <div className="text-blue-200">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
